const sizes = {
  mobileL: "425px",
  tablet: "768px",
};
export const devices = {
  
  
  mobileL: `(max-width: ${sizes.mobileL})`,
  tablet: `(max-width: ${sizes.tablet})`,

};
